import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from "class-variance-authority";
import React from "react";
import { cn } from "../../lib/cn";
const buttonVariants = cva("inline-flex items-center justify-center gap-2 rounded-lg text-sm font-medium transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50", {
    variants: {
        variant: {
            primary: "bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-md hover:from-purple-700 hover:to-blue-700 hover:shadow-lg hover:scale-[1.02]",
            secondary: "border border-border bg-card text-foreground hover:bg-muted dark:hover:bg-muted/80",
            danger: "bg-rose-600 text-white shadow-md hover:bg-rose-700",
            ghost: "text-purple-600 hover:bg-purple-50 dark:text-purple-400 dark:hover:bg-purple-900/20",
            outlineMuted: "border border-border bg-transparent text-muted-foreground hover:bg-muted/60",
        },
        size: {
            sm: "h-8 px-3",
            md: "h-10 px-4",
            lg: "h-11 px-6 text-base",
            icon: "h-10 w-10 shrink-0 p-0",
        },
    },
    defaultVariants: {
        variant: "primary",
        size: "md",
    },
});
export const Button = React.forwardRef(({ className, variant, size, type = "button", ...props }, ref) => (_jsx("button", { ref: ref, type: type, className: cn(buttonVariants({ variant, size }), className), ...props })));
Button.displayName = "Button";
